module.exports = "<div class=\"am4-login\">\n  <div class=\"am4-login__background\">\n    <div class=\"am4-login__window\">\n      <header class=\"am4-login__header\">\n        <a\n          ui-sref=\"app.login\"\n          class=\"am4-login__back\"\n          data-cy=\"forgotBackToLogin\"\n        >\n          <i class=\"fa fa-angle-left\"></i>\n        </a>\n        <span>{{'RESET_YOUR_PASSWORD' | translate}}</span>\n      </header>\n\n      <ui-view></ui-view>\n    </div>\n  </div>\n</div>\n\n<div class=\"am4-navigation\">\n  <div class=\"am4-navigation__logo\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/forgot/layout.html
// module id = 161
// module chunks = 14